// extracted by mini-css-extract-plugin
export default {"header":"panelWrapper_header__3NN3R","titleGroup":"panelWrapper_titleGroup__dVBp+","card-title":"panelWrapper_card-title__SQt5P"};